import React from "react";
import clsx from "clsx";
import { GRAY, BACKGROUND } from "Components/constants";
import styles from "./Head.module.css";

type HeadProps = {
    color?: number | number[];
    replica?: boolean;
    text: string;
    backgroundless?: boolean;
    className?: string;
};

const Head = ({
    text,
    replica,
    color,
    backgroundless = false,
    className,
}: HeadProps) => {
    const colorArray = React.useMemo(() => {
        if (!Array.isArray(color)) return [color ?? GRAY];
        if (color.length === 0) return [GRAY];
        return color;
    }, [color]);

    return (
        <div
            className={clsx(styles.root, className)}
            style={{
                backgroundColor: `#${BACKGROUND?.toString(16)}`,
                borderColor: !backgroundless
                    ? `#${colorArray[0].toString(16)}`
                    : undefined,
            }}
        >
            {!backgroundless && (
                <div
                    className={clsx(styles.background, {
                        [styles.replica]: replica,
                    })}
                >
                    {colorArray.map((c) => (
                        <div
                            key={c}
                            className={styles.color}
                            style={{
                                backgroundColor: `#${c?.toString(16)}`,
                            }}
                        />
                    ))}
                </div>
            )}

            <div
                className={styles.label}
                style={{
                    color:
                        replica || backgroundless
                            ? `#${colorArray[0].toString(16)}`
                            : "white",
                }}
            >
                {text}
            </div>
        </div>
    );
};

export default Head;
